import { delay } from 'src/common/helpers/delay-helper';
import { getPOSServiceTypeFromBFF } from 'src/xlr-configuration/pos-service-type-utils';
import { ServiceType } from 'src/xlr-configuration/service-type';

export const requestPOSServiceType = async (
  retryDelay: number,
  remainingTries: number,
): Promise<ServiceType> => {
  const onError = async (err: string): Promise<ServiceType> => {
    if (!remainingTries) {
      throw err;
    }
    await delay(retryDelay);
    return requestPOSServiceType(retryDelay, remainingTries - 1);
  };
  return getPOSServiceTypeFromBFF().catch(onError);
};
